/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PostPutRegionMenuSettingRequestAdmin } from '../models/PostPutRegionMenuSettingRequestAdmin';
import type { RegionMenuSettingAdminDto } from '../models/RegionMenuSettingAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegionMenuSettingsService {
    /**
     * **Required Policy:** `ViewMenuScreens`
     * @returns RegionMenuSettingAdminDto OK
     * @throws ApiError
     */
    public static getRegionMenuSettingAdmin({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<RegionMenuSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/regionmenusettings/{regionId}',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMenuScreens`
     * @returns RegionMenuSettingAdminDto OK
     * @throws ApiError
     */
    public static upsertRegionMenuSettingAdmin({
        regionId,
        requestBody,
    }: {
        regionId: number,
        requestBody?: PostPutRegionMenuSettingRequestAdmin,
    }): CancelablePromise<RegionMenuSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/regionmenusettings/{regionId}',
            path: {
                'regionId': regionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMenuScreens`
     * @returns RegionMenuSettingAdminDto OK
     * @throws ApiError
     */
    public static deleteRegionMenuSettingAdmin({
        regionId,
        menuScreenId,
    }: {
        regionId: number,
        menuScreenId: string,
    }): CancelablePromise<RegionMenuSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/regionmenusettings/{regionId}/{menuScreenId}',
            path: {
                'regionId': regionId,
                'menuScreenId': menuScreenId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
